export default {
    'EUR': '€',
    'USD': '$' 
}